export const GET_TREND_SIGNALS = "GET_TREND_SIGNALS";
export const GET_TREND_SIGNALS_SUCCESS = "GET_TREND_SIGNALS_SUCCESS";
export const GET_TREND_SIGNALS_ERROR = "GET_TREND_SIGNALS_ERROR";
export const GET_STRATIFIED_TREND_SIGNALS = "GET_STRATIFIED_TREND_SIGNALS";
export const GET_STRATIFIED_TREND_SIGNALS_SUCCESS = "GET_STRATIFIED_TREND_SIGNALS_SUCCESS";
export const GET_STRATIFIED_TREND_SIGNALS_ERROR = "GET_STRATIFIED_TREND_SIGNALS_ERROR";
export const RESET_TREND_CHART_PARAMETERS = "RESET_TREND_CHART_PARAMETERS";
